import {
  RECEIVE_LOGIN_REQUEST,
  GET_CURRENT_USER_REQUEST,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
  AUTH_CHECK_REQUEST,
  AUTH_CHECK_SUCCESS,
  AUTH_CHECK_FAIL, AUTH_EXPIRED
} from '../../../common/constants/action-constants';
import { NavigateFunction } from 'react-router-dom';

export type AuthCheckRequestAction = {
  type: typeof AUTH_CHECK_REQUEST;
  // navigate?: NavigateFunction;
};

export type AuthCheckSuccessAction = {
  type: typeof AUTH_CHECK_SUCCESS;
};

export type AuthCheckFailAction = {
  type: typeof AUTH_CHECK_FAIL;
};

export type AuthExpiredAction = {
  type: typeof AUTH_EXPIRED;
}

export type ReceiveLoginRequestAction = {
  type: typeof RECEIVE_LOGIN_REQUEST;
  code: string;
  token: string;
  navigate: NavigateFunction;
};

export type GetCurrentUserRequestAction = {
  type: typeof GET_CURRENT_USER_REQUEST;
  navigate: NavigateFunction;
};

export type GetCurrentUserSuccessAction = {
  type: typeof GET_CURRENT_USER_SUCCESS;
  user: any,
};

export type GetCurrentUserErrorAction = {
  type: typeof GET_CURRENT_USER_ERROR;
  error: unknown;
};

export const authCheckRequest = (): AuthCheckRequestAction => ({
  type: AUTH_CHECK_REQUEST,
});

export const authCheckSuccess = (): AuthCheckSuccessAction => ({
  type: AUTH_CHECK_SUCCESS,
});

export const authCheckFail = (): AuthCheckFailAction => ({
  type: AUTH_CHECK_FAIL,
});

export const authExpired = (): AuthExpiredAction => ({
  type: AUTH_EXPIRED,
})

/**action checks if received from google-auth user exists in the database**/
export const receiveLoginRequest = (code: string, token: string, navigate: NavigateFunction): ReceiveLoginRequestAction => {
  return {
    type: RECEIVE_LOGIN_REQUEST,
    code,
    token,
    navigate,
  };
};

export const getCurrentUserRequest = (navigate: NavigateFunction): GetCurrentUserRequestAction => {
  return {
    type: GET_CURRENT_USER_REQUEST,
    navigate,
  };
};

export const getCurrentUserSuccess = (user: any): GetCurrentUserSuccessAction => {
  return {
    type: GET_CURRENT_USER_SUCCESS,
    user: user,
  };
};

export const getCurrentUserError = (error: unknown): GetCurrentUserErrorAction => {
   return {
    type: GET_CURRENT_USER_ERROR,
    error,
  };
};

export type AuthActions =
  | ReturnType<typeof authCheckRequest>
  | ReturnType<typeof authCheckSuccess>
  | ReturnType<typeof authCheckFail>;
